// Auto-generated from database - DO NOT EDIT MANUALLY
// Generated on: 2026-10-15T05:45:00.168Z
// Run 'npm run generate:categories' to regenerate
//
// This file replaces data/js/product-categories.ts for static category data

// =============================================================================
// CONDITION CONSTANTS (Static - not from database)
// =============================================================================

export const CONDITIONS = [
  {
    label: "Brand New",
    id: 5,
    description: "",
  },
  {
    label: "Like New",
    id: 4,
    description: "",
  },
  {
    label: "Good",
    id: 3,
    description: "",
  },
  {
    label: "Gently Used",
    id: 2,
    description: "",
  },
  {
    label: "Quite Used",
    id: 1,
    description: "",
  },
];

export const BRANDS = [{}];
export const COLORS = ["red", "yellow", "green"];

// =============================================================================
// CATEGORY DATA (Generated from database)
// =============================================================================

export const VEHICLE_SUBCATS: number[] = [43,158,291,159,292,160,161,95,162,163,164,157];
export const NON_SHIPABLE_CATS: number[] = [];
export const NON_SHIPABLE_SUBCATS: number[] = [];

export const Cats: Record<number, { label: string; sortOrder: number; slug: string }> = {
  "0": {
    label: "All",
    sortOrder: 0,
    slug: ""
  },
  "12": {
    label: "Vehicles",
    sortOrder: 1,
    slug: "vehicles"
  },
  "15": {
    label: "Electronics",
    sortOrder: 2,
    slug: "electronics"
  },
  "16": {
    label: "Pets",
    sortOrder: 13,
    slug: "pets"
  },
  "17": {
    label: "Sports",
    sortOrder: 9,
    slug: "sports"
  },
  "19": {
    label: "Home & Garden",
    sortOrder: 7,
    slug: "home-garden"
  },
  "20": {
    label: "Kids & Baby",
    sortOrder: 12,
    slug: "kids-baby"
  },
  "23": {
    label: "Fashion",
    sortOrder: 6,
    slug: "fashion"
  },
  "24": {
    label: "Jewelry",
    sortOrder: 8,
    slug: "jewelry"
  },
  "25": {
    label: "Art & Collectibles",
    sortOrder: 10,
    slug: "art-collectibles"
  },
  "26": {
    label: "Music",
    sortOrder: 3,
    slug: "music"
  },
  "34": {
    label: "Tools",
    sortOrder: 5,
    slug: "tools"
  },
  "35": {
    label: "Games, Toys, Hobbies",
    sortOrder: 11,
    slug: "games-toys-hobbies"
  },
  "37": {
    label: "Books",
    sortOrder: 14,
    slug: "books"
  },
  "38": {
    label: "Movies",
    sortOrder: 4,
    slug: "movies"
  }
};

export const SubCats: Record<number, { label: string; group: number; sortOrder: number; slug: string; heading: any; subheading: any }> = {
  "43": {
    label: "Cars",
    group: 12,
    sortOrder: 1,
    slug: "cars",
    heading: [
      "Cars"
    ],
    subheading: []
  },
  "57": {
    label: "Bikes",
    group: 17,
    sortOrder: 49,
    slug: "bikes",
    heading: [
      "Bikes"
    ],
    subheading: []
  },
  "61": {
    label: "Furniture",
    group: 19,
    sortOrder: 40,
    slug: "furniture",
    heading: [
      "Furniture"
    ],
    subheading: []
  },
  "62": {
    label: "Appliances",
    group: 19,
    sortOrder: 42,
    slug: "appliances",
    heading: [
      "Appliances"
    ],
    subheading: []
  },
  "64": {
    label: "Lawn & Garden",
    group: 19,
    sortOrder: 43,
    slug: "lawn-garden",
    heading: [
      "Lawn & Garden"
    ],
    subheading: []
  },
  "66": {
    label: "Baby Clothes",
    group: 20,
    sortOrder: 62,
    slug: "baby-clothes",
    heading: [
      "Baby Clothes"
    ],
    subheading: []
  },
  "69": {
    label: "Shoes",
    group: 23,
    sortOrder: 37,
    slug: "shoes",
    heading: [
      "Shoes"
    ],
    subheading: []
  },
  "74": {
    label: "Art",
    group: 25,
    sortOrder: 55,
    slug: "art",
    heading: [
      "Art"
    ],
    subheading: []
  },
  "95": {
    label: "Motorcycles",
    group: 12,
    sortOrder: 6,
    slug: "motorcycles",
    heading: [
      "Motorcycles"
    ],
    subheading: []
  },
  "157": {
    label: "Parts",
    group: 12,
    sortOrder: 11,
    slug: "parts",
    heading: [
      "Parts"
    ],
    subheading: []
  },
  "158": {
    label: "Electric Cars",
    group: 12,
    sortOrder: 2,
    slug: "electric-cars",
    heading: [
      "Electric Cars"
    ],
    subheading: []
  },
  "159": {
    label: "Classics, Collectors, and SuperCars",
    group: 12,
    sortOrder: 3,
    slug: "classics-collectors-and-supercars",
    heading: [
      "Classics, Collectors, and SuperCars"
    ],
    subheading: []
  },
  "160": {
    label: "Boats, Jetskis, & Other Motorized Watercraft",
    group: 12,
    sortOrder: 4,
    slug: "boats-jetskis-other-motorized-watercraft",
    heading: [
      "Boats, Jetskis, & Other Motorized Watercraft"
    ],
    subheading: []
  },
  "161": {
    label: "Trucks",
    group: 12,
    sortOrder: 5,
    slug: "trucks",
    heading: [
      "Trucks"
    ],
    subheading: []
  },
  "162": {
    label: "RVs",
    group: 12,
    sortOrder: 7,
    slug: "rvs",
    heading: [
      "RVs"
    ],
    subheading: []
  },
  "163": {
    label: "Tires & Rims",
    group: 12,
    sortOrder: 8,
    slug: "tires-rims",
    heading: [
      "Tires & Rims"
    ],
    subheading: []
  },
  "164": {
    label: "Trailers",
    group: 12,
    sortOrder: 9,
    slug: "trailers",
    heading: [
      "Trailers"
    ],
    subheading: []
  },
  "165": {
    label: "Computers",
    group: 15,
    sortOrder: 13,
    slug: "computers",
    heading: [
      "Computers"
    ],
    subheading: []
  },
  "166": {
    label: "Phones / Tablets",
    group: 15,
    sortOrder: 14,
    slug: "phones-tablets",
    heading: [
      "Phones / Tablets"
    ],
    subheading: []
  },
  "167": {
    label: "Audio",
    group: 15,
    sortOrder: 15,
    slug: "audio",
    heading: [
      "Audio"
    ],
    subheading: []
  },
  "168": {
    label: "Wearables",
    group: 15,
    sortOrder: 16,
    slug: "wearables",
    heading: [
      "Wearables"
    ],
    subheading: []
  },
  "169": {
    label: "Drones",
    group: 15,
    sortOrder: 17,
    slug: "drones",
    heading: [
      "Drones"
    ],
    subheading: []
  },
  "170": {
    label: "TVs",
    group: 15,
    sortOrder: 18,
    slug: "tvs",
    heading: [
      "TVs"
    ],
    subheading: []
  },
  "171": {
    label: "Video Games",
    group: 15,
    sortOrder: 19,
    slug: "video-games",
    heading: [
      "Video Games"
    ],
    subheading: []
  },
  "172": {
    label: "Cameras",
    group: 15,
    sortOrder: 12,
    slug: "cameras",
    heading: [
      "Cameras"
    ],
    subheading: []
  },
  "173": {
    label: "Guitars / Bass",
    group: 26,
    sortOrder: 26,
    slug: "guitars-bass",
    heading: [
      "Guitars / Bass"
    ],
    subheading: []
  },
  "174": {
    label: "Amps / Speakers",
    group: 26,
    sortOrder: 27,
    slug: "amps-speakers",
    heading: [
      "Amps / Speakers"
    ],
    subheading: []
  },
  "175": {
    label: "Drums / Percussion",
    group: 26,
    sortOrder: 28,
    slug: "drums-percussion",
    heading: [
      "Drums / Percussion"
    ],
    subheading: []
  },
  "176": {
    label: "Keyboards / Pianos",
    group: 26,
    sortOrder: 29,
    slug: "keyboards-pianos",
    heading: [
      "Keyboards / Pianos"
    ],
    subheading: []
  },
  "177": {
    label: "Hand Tools",
    group: 34,
    sortOrder: 30,
    slug: "hand-tools",
    heading: [
      "Hand Tools"
    ],
    subheading: []
  },
  "178": {
    label: "Power Tools",
    group: 34,
    sortOrder: 31,
    slug: "power-tools",
    heading: [
      "Power Tools"
    ],
    subheading: []
  },
  "179": {
    label: "Storage & Workbenches",
    group: 34,
    sortOrder: 32,
    slug: "storage-workbenches",
    heading: [
      "Storage & Workbenches"
    ],
    subheading: []
  },
  "180": {
    label: "Parts / DIY Kits",
    group: 34,
    sortOrder: 33,
    slug: "parts-diy-kits",
    heading: [
      "Parts / DIY Kits"
    ],
    subheading: []
  },
  "184": {
    label: "Accessories",
    group: 23,
    sortOrder: 38,
    slug: "accessories",
    heading: [
      "Accessories"
    ],
    subheading: []
  },
  "185": {
    label: "Tools & Machines",
    group: 34,
    sortOrder: 41,
    slug: "tools-machines",
    heading: [
      "Tools & Machines"
    ],
    subheading: []
  },
  "186": {
    label: "Home Decor",
    group: 19,
    sortOrder: 44,
    slug: "home-decor",
    heading: [
      "Home Decor"
    ],
    subheading: []
  },
  "188": {
    label: "Womens Jewelry",
    group: 24,
    sortOrder: 46,
    slug: "womens-jewelry",
    heading: [
      "Womens Jewelry"
    ],
    subheading: []
  },
  "189": {
    label: "Mens Jewelry",
    group: 24,
    sortOrder: 47,
    slug: "mens-jewelry",
    heading: [
      "Mens Jewelry"
    ],
    subheading: []
  },
  "190": {
    label: "Shoes",
    group: 17,
    sortOrder: 51,
    slug: "shoes-2",
    heading: [
      "Shoes"
    ],
    subheading: []
  },
  "191": {
    label: "Exercise Equipment",
    group: 17,
    sortOrder: 52,
    slug: "exercise-equipment",
    heading: [
      "Exercise Equipment"
    ],
    subheading: []
  },
  "192": {
    label: "Sports Equipment",
    group: 17,
    sortOrder: 53,
    slug: "sports-equipment",
    heading: [
      "Sports Equipment"
    ],
    subheading: []
  },
  "193": {
    label: "Kayaks, Paddle Boards, & Other Non-Motorized Watercraft",
    group: 17,
    sortOrder: 54,
    slug: "kayaks-paddle-boards-other-non-motorized-watercraft",
    heading: [
      "Kayaks, Paddle Boards, & Other Non-Motorized Watercraft"
    ],
    subheading: []
  },
  "194": {
    label: "Antiques & Vintage",
    group: 25,
    sortOrder: 56,
    slug: "antiques-vintage",
    heading: [
      "Antiques & Vintage"
    ],
    subheading: []
  },
  "195": {
    label: "Collectibles",
    group: 25,
    sortOrder: 57,
    slug: "collectibles",
    heading: [
      "Collectibles"
    ],
    subheading: []
  },
  "196": {
    label: "Toys",
    group: 35,
    sortOrder: 58,
    slug: "toys",
    heading: [
      "Toys"
    ],
    subheading: []
  },
  "197": {
    label: "Games & Puzzles",
    group: 35,
    sortOrder: 59,
    slug: "games-puzzles",
    heading: [
      "Games & Puzzles"
    ],
    subheading: []
  },
  "198": {
    label: "Trading Cards",
    group: 35,
    sortOrder: 60,
    slug: "trading-cards",
    heading: [
      "Trading Cards"
    ],
    subheading: []
  },
  "200": {
    label: "Cribs & Strollers",
    group: 20,
    sortOrder: 63,
    slug: "cribs-strollers",
    heading: [
      "Cribs & Strollers"
    ],
    subheading: []
  },
  "201": {
    label: "Toys",
    group: 20,
    sortOrder: 64,
    slug: "toys-2",
    heading: [
      "Toys"
    ],
    subheading: []
  },
  "202": {
    label: "Costumes & Accessories",
    group: 20,
    sortOrder: 65,
    slug: "costumes-accessories",
    heading: [
      "Costumes & Accessories"
    ],
    subheading: []
  },
  "204": {
    label: "Pet Supplies",
    group: 16,
    sortOrder: 70,
    slug: "pet-supplies",
    heading: [
      "Pet Supplies"
    ],
    subheading: []
  },
  "205": {
    label: "Pet Food",
    group: 16,
    sortOrder: 71,
    slug: "pet-food",
    heading: [
      "Pet Food"
    ],
    subheading: []
  },
  "206": {
    label: "Adoption",
    group: 16,
    sortOrder: 72,
    slug: "adoption",
    heading: [
      "Adoption"
    ],
    subheading: []
  },
  "207": {
    label: "Vinyl",
    group: 26,
    sortOrder: 73,
    slug: "vinyl",
    heading: [
      "Vinyl"
    ],
    subheading: []
  },
  "208": {
    label: "Cassette Tapes",
    group: 26,
    sortOrder: 74,
    slug: "cassette-tapes",
    heading: [
      "Cassette Tapes"
    ],
    subheading: []
  },
  "209": {
    label: "CDs",
    group: 26,
    sortOrder: 75,
    slug: "cds",
    heading: [
      "CDs"
    ],
    subheading: []
  },
  "211": {
    label: "Music Memorabilia",
    group: 26,
    sortOrder: 77,
    slug: "memorabilia",
    heading: [
      "Music Memorabilia"
    ],
    subheading: []
  },
  "212": {
    label: "Fiction",
    group: 37,
    sortOrder: 85,
    slug: "fiction",
    heading: [
      "Fiction"
    ],
    subheading: []
  },
  "213": {
    label: "Non-Fiction",
    group: 37,
    sortOrder: 86,
    slug: "non-fiction",
    heading: [
      "Non-Fiction"
    ],
    subheading: []
  },
  "214": {
    label: "Science Fiction",
    group: 37,
    sortOrder: 87,
    slug: "science-fiction",
    heading: [
      "Science Fiction"
    ],
    subheading: []
  },
  "215": {
    label: "Historical Fiction",
    group: 37,
    sortOrder: 88,
    slug: "historical-fiction",
    heading: [
      "Historical Fiction"
    ],
    subheading: []
  },
  "216": {
    label: "Fantasy",
    group: 37,
    sortOrder: 89,
    slug: "fantasy",
    heading: [
      "Fantasy"
    ],
    subheading: []
  },
  "217": {
    label: "Mystery",
    group: 37,
    sortOrder: 90,
    slug: "mystery",
    heading: [
      "Mystery"
    ],
    subheading: []
  },
  "218": {
    label: "Horror",
    group: 37,
    sortOrder: 91,
    slug: "horror",
    heading: [
      "Horror"
    ],
    subheading: []
  },
  "219": {
    label: "Romance Novels",
    group: 37,
    sortOrder: 92,
    slug: "romance-novels",
    heading: [
      "Romance Novels"
    ],
    subheading: []
  },
  "220": {
    label: "Thriller",
    group: 37,
    sortOrder: 93,
    slug: "thriller",
    heading: [
      "Thriller"
    ],
    subheading: []
  },
  "221": {
    label: "Literary Fiction",
    group: 37,
    sortOrder: 94,
    slug: "literary-fiction",
    heading: [
      "Literary Fiction"
    ],
    subheading: []
  },
  "222": {
    label: "Short Stories",
    group: 37,
    sortOrder: 95,
    slug: "short-stories",
    heading: [
      "Short Stories"
    ],
    subheading: []
  },
  "223": {
    label: "Graphic Novels",
    group: 37,
    sortOrder: 96,
    slug: "graphic-novels",
    heading: [
      "Graphic Novels"
    ],
    subheading: []
  },
  "224": {
    label: "Literature",
    group: 37,
    sortOrder: 97,
    slug: "literature",
    heading: [
      "Literature"
    ],
    subheading: []
  },
  "225": {
    label: "Science Fantasy",
    group: 37,
    sortOrder: 98,
    slug: "science-fantasy",
    heading: [
      "Science Fantasy"
    ],
    subheading: []
  },
  "226": {
    label: "Paranormal Romance",
    group: 37,
    sortOrder: 99,
    slug: "paranormal-romance",
    heading: [
      "Paranormal Romance"
    ],
    subheading: []
  },
  "227": {
    label: "Childrens Literature",
    group: 37,
    sortOrder: 100,
    slug: "childrens-literature",
    heading: [
      "Childrens Literature"
    ],
    subheading: []
  },
  "228": {
    label: "Dystopia",
    group: 37,
    sortOrder: 101,
    slug: "dystopia",
    heading: [
      "Dystopia"
    ],
    subheading: []
  },
  "229": {
    label: "Biography",
    group: 37,
    sortOrder: 102,
    slug: "biography",
    heading: [
      "Biography"
    ],
    subheading: []
  },
  "230": {
    label: "Magical Realism",
    group: 37,
    sortOrder: 103,
    slug: "magical-realism",
    heading: [
      "Magical Realism"
    ],
    subheading: []
  },
  "231": {
    label: "Adventure Fiction",
    group: 37,
    sortOrder: 104,
    slug: "adventure-fiction",
    heading: [
      "Adventure Fiction"
    ],
    subheading: []
  },
  "232": {
    label: "Contemporary Romance",
    group: 37,
    sortOrder: 105,
    slug: "contemporary-romance",
    heading: [
      "Contemporary Romance"
    ],
    subheading: []
  },
  "233": {
    label: "Fairy Tale",
    group: 37,
    sortOrder: 106,
    slug: "fairy-tale",
    heading: [
      "Fairy Tale"
    ],
    subheading: []
  },
  "234": {
    label: "Western Fiction",
    group: 37,
    sortOrder: 107,
    slug: "western-fiction",
    heading: [
      "Western Fiction"
    ],
    subheading: []
  },
  "235": {
    label: "Steampunk",
    group: 37,
    sortOrder: 108,
    slug: "steampunk",
    heading: [
      "Steampunk"
    ],
    subheading: []
  },
  "236": {
    label: "DVDs",
    group: 38,
    sortOrder: 82,
    slug: "dvds",
    heading: [
      "DVDs"
    ],
    subheading: []
  },
  "237": {
    label: "Blu-ray",
    group: 38,
    sortOrder: 83,
    slug: "blu-ray",
    heading: [
      "Blu-ray"
    ],
    subheading: []
  },
  "238": {
    label: "VHS",
    group: 38,
    sortOrder: 84,
    slug: "vhs",
    heading: [
      "VHS"
    ],
    subheading: []
  },
  "240": {
    label: "Beauty & Fragrance",
    group: 23,
    sortOrder: 38,
    slug: "beauty-fragrance",
    heading: [
      "Beauty & Fragrance"
    ],
    subheading: []
  },
  "241": {
    label: "Kitchen & Dining",
    group: 19,
    sortOrder: 44,
    slug: "kitchen-dining",
    heading: [
      "Kitchen & Dining"
    ],
    subheading: []
  },
  "242": {
    label: "Holiday & Seasonal",
    group: 19,
    sortOrder: 44,
    slug: "holiday-seasonal",
    heading: [
      "Holiday & Seasonal"
    ],
    subheading: []
  },
  "243": {
    label: "Sewing & Crafts",
    group: 35,
    sortOrder: 60,
    slug: "sewing-crafts",
    heading: [
      "Sewing & Crafts"
    ],
    subheading: []
  },
  "244": {
    label: "Fan Gear",
    group: 17,
    sortOrder: 34,
    slug: "fan-gear",
    heading: [
      "Fan Gear"
    ],
    subheading: []
  },
  "245": {
    label: "Plush & Stuffed Animals",
    group: 35,
    sortOrder: 60,
    slug: "plush-stuffed-animals",
    heading: [
      "Plush & Stuffed Animals"
    ],
    subheading: []
  },
  "246": {
    label: "Kids Clothing",
    group: 20,
    sortOrder: 65,
    slug: "kids-clothing",
    heading: [
      "Kids Clothing"
    ],
    subheading: []
  },
  "247": {
    label: "Bedding & Bath",
    group: 19,
    sortOrder: 44,
    slug: "bedding-bath",
    heading: [
      "Bedding & Bath"
    ],
    subheading: []
  },
  "248": {
    label: "Vintage Print Ads",
    group: 25,
    sortOrder: 70,
    slug: "vintage-print-ads",
    heading: [
      "Vintage Print Ads"
    ],
    subheading: []
  },
  "249": {
    label: "Business Cards",
    group: 25,
    sortOrder: 71,
    slug: "business-cards",
    heading: [
      "Business Cards"
    ],
    subheading: []
  },
  "250": {
    label: "Matchbook Covers",
    group: 25,
    sortOrder: 72,
    slug: "matchbook-covers",
    heading: [
      "Matchbook Covers"
    ],
    subheading: []
  },
  "251": {
    label: "Postcards",
    group: 25,
    sortOrder: 73,
    slug: "postcards",
    heading: [
      "Postcards"
    ],
    subheading: []
  },
  "252": {
    label: "Engravings & Antique Prints",
    group: 25,
    sortOrder: 74,
    slug: "engravings-antique-prints",
    heading: [
      "Engravings & Antique Prints"
    ],
    subheading: []
  },
  "253": {
    label: "Billheads, Letters & Documents",
    group: 25,
    sortOrder: 75,
    slug: "billheads-letters-documents",
    heading: [
      "Billheads, Letters & Documents"
    ],
    subheading: []
  },
  "254": {
    label: "Vintage Photographs",
    group: 25,
    sortOrder: 76,
    slug: "vintage-photographs",
    heading: [
      "Vintage Photographs"
    ],
    subheading: []
  },
  "255": {
    label: "Pins & Badges",
    group: 25,
    sortOrder: 77,
    slug: "pins-badges",
    heading: [
      "Pins & Badges"
    ],
    subheading: []
  },
  "256": {
    label: "Magazines & Periodicals",
    group: 25,
    sortOrder: 78,
    slug: "magazines-periodicals",
    heading: [
      "Magazines & Periodicals"
    ],
    subheading: []
  },
  "257": {
    label: "Maps & Travel Brochures",
    group: 25,
    sortOrder: 79,
    slug: "maps-travel-brochures",
    heading: [
      "Maps & Travel Brochures"
    ],
    subheading: []
  },
  "258": {
    label: "Trade Cards",
    group: 25,
    sortOrder: 80,
    slug: "trade-cards",
    heading: [
      "Trade Cards"
    ],
    subheading: []
  },
  "259": {
    label: "Stamps & Postal History",
    group: 25,
    sortOrder: 81,
    slug: "stamps-postal-history",
    heading: [
      "Stamps & Postal History"
    ],
    subheading: []
  },
  "260": {
    label: "Figurines",
    group: 25,
    sortOrder: 82,
    slug: "figurines",
    heading: [
      "Figurines"
    ],
    subheading: []
  },
  "261": {
    label: "Rocks, Minerals & Fossils",
    group: 25,
    sortOrder: 83,
    slug: "rocks-minerals-fossils",
    heading: [
      "Rocks, Minerals & Fossils"
    ],
    subheading: []
  },
  "262": {
    label: "Earrings",
    group: 24,
    sortOrder: 39,
    slug: "earrings",
    heading: [
      "Earrings"
    ],
    subheading: []
  },
  "263": {
    label: "Necklaces & Pendants",
    group: 24,
    sortOrder: 40,
    slug: "necklaces-pendants",
    heading: [
      "Necklaces & Pendants"
    ],
    subheading: []
  },
  "264": {
    label: "Bracelets & Bangles",
    group: 24,
    sortOrder: 41,
    slug: "bracelets-bangles",
    heading: [
      "Bracelets & Bangles"
    ],
    subheading: []
  },
  "265": {
    label: "Rings",
    group: 24,
    sortOrder: 42,
    slug: "rings",
    heading: [
      "Rings"
    ],
    subheading: []
  },
  "266": {
    label: "Watches",
    group: 24,
    sortOrder: 43,
    slug: "watches",
    heading: [
      "Watches"
    ],
    subheading: []
  },
  "267": {
    label: "Brooches & Pins",
    group: 24,
    sortOrder: 44,
    slug: "brooches-pins",
    heading: [
      "Brooches & Pins"
    ],
    subheading: []
  },
  "268": {
    label: "Charms",
    group: 24,
    sortOrder: 45,
    slug: "charms",
    heading: [
      "Charms"
    ],
    subheading: []
  },
  "269": {
    label: "Dresses",
    group: 23,
    sortOrder: 20,
    slug: "dresses",
    heading: [
      "Dresses"
    ],
    subheading: []
  },
  "270": {
    label: "Tops & Shirts",
    group: 23,
    sortOrder: 21,
    slug: "tops-shirts",
    heading: [
      "Tops & Shirts"
    ],
    subheading: []
  },
  "271": {
    label: "Sweaters & Hoodies",
    group: 23,
    sortOrder: 22,
    slug: "sweaters-hoodies",
    heading: [
      "Sweaters & Hoodies"
    ],
    subheading: []
  },
  "272": {
    label: "Coats & Jackets",
    group: 23,
    sortOrder: 23,
    slug: "coats-jackets",
    heading: [
      "Coats & Jackets"
    ],
    subheading: []
  },
  "273": {
    label: "Pants & Jeans",
    group: 23,
    sortOrder: 24,
    slug: "pants-jeans",
    heading: [
      "Pants & Jeans"
    ],
    subheading: []
  },
  "274": {
    label: "Skirts",
    group: 23,
    sortOrder: 25,
    slug: "skirts",
    heading: [
      "Skirts"
    ],
    subheading: []
  },
  "275": {
    label: "Shorts",
    group: 23,
    sortOrder: 26,
    slug: "shorts",
    heading: [
      "Shorts"
    ],
    subheading: []
  },
  "276": {
    label: "Activewear",
    group: 23,
    sortOrder: 27,
    slug: "activewear",
    heading: [
      "Activewear"
    ],
    subheading: []
  },
  "277": {
    label: "Swimwear",
    group: 23,
    sortOrder: 28,
    slug: "swimwear",
    heading: [
      "Swimwear"
    ],
    subheading: []
  },
  "278": {
    label: "Sleepwear & Intimates",
    group: 23,
    sortOrder: 29,
    slug: "sleepwear-intimates",
    heading: [
      "Sleepwear & Intimates"
    ],
    subheading: []
  },
  "279": {
    label: "Suits & Blazers",
    group: 23,
    sortOrder: 30,
    slug: "suits-blazers",
    heading: [
      "Suits & Blazers"
    ],
    subheading: []
  },
  "280": {
    label: "Sneakers",
    group: 23,
    sortOrder: 31,
    slug: "sneakers",
    heading: [
      "Sneakers"
    ],
    subheading: []
  },
  "281": {
    label: "Boots",
    group: 23,
    sortOrder: 32,
    slug: "boots",
    heading: [
      "Boots"
    ],
    subheading: []
  },
  "282": {
    label: "Heels",
    group: 23,
    sortOrder: 33,
    slug: "heels",
    heading: [
      "Heels"
    ],
    subheading: []
  },
  "283": {
    label: "Sandals",
    group: 23,
    sortOrder: 34,
    slug: "sandals",
    heading: [
      "Sandals"
    ],
    subheading: []
  },
  "284": {
    label: "Flats & Loafers",
    group: 23,
    sortOrder: 35,
    slug: "flats-loafers",
    heading: [
      "Flats & Loafers"
    ],
    subheading: []
  },
  "285": {
    label: "Handbags & Purses",
    group: 23,
    sortOrder: 36,
    slug: "handbags-purses",
    heading: [
      "Handbags & Purses"
    ],
    subheading: []
  },
  "286": {
    label: "Wallets",
    group: 23,
    sortOrder: 37,
    slug: "wallets",
    heading: [
      "Wallets"
    ],
    subheading: []
  },
  "287": {
    label: "Backpacks",
    group: 23,
    sortOrder: 38,
    slug: "backpacks",
    heading: [
      "Backpacks"
    ],
    subheading: []
  },
  "288": {
    label: "Hats",
    group: 23,
    sortOrder: 39,
    slug: "hats",
    heading: [
      "Hats"
    ],
    subheading: []
  },
  "289": {
    label: "Sunglasses & Eyewear",
    group: 23,
    sortOrder: 40,
    slug: "sunglasses-eyewear",
    heading: [
      "Sunglasses & Eyewear"
    ],
    subheading: []
  },
  "290": {
    label: "Belts",
    group: 23,
    sortOrder: 41,
    slug: "belts",
    heading: [
      "Belts"
    ],
    subheading: []
  },
  "291": {
    label: "SUVs",
    group: 12,
    sortOrder: 2,
    slug: "suvs",
    heading: [
      "SUVs"
    ],
    subheading: []
  },
  "292": {
    label: "Vans & Minivans",
    group: 12,
    sortOrder: 3,
    slug: "vans-minivans",
    heading: [
      "Vans & Minivans"
    ],
    subheading: []
  },
  "293": {
    label: "Fan Apparel",
    group: 17,
    sortOrder: 60,
    slug: "fan-apparel",
    heading: [
      "Fan Apparel"
    ],
    subheading: []
  },
  "294": {
    label: "Fan Footwear & Socks",
    group: 17,
    sortOrder: 61,
    slug: "fan-footwear-socks",
    heading: [
      "Fan Footwear & Socks"
    ],
    subheading: []
  },
  "295": {
    label: "Fan Phone Cases & Tech",
    group: 17,
    sortOrder: 62,
    slug: "fan-phone-cases-tech",
    heading: [
      "Fan Phone Cases & Tech"
    ],
    subheading: []
  },
  "296": {
    label: "Flags & Banners",
    group: 17,
    sortOrder: 63,
    slug: "flags-banners",
    heading: [
      "Flags & Banners"
    ],
    subheading: []
  },
  "297": {
    label: "Fan Home & Tailgate",
    group: 17,
    sortOrder: 64,
    slug: "fan-home-tailgate",
    heading: [
      "Fan Home & Tailgate"
    ],
    subheading: []
  },
  "298": {
    label: "Fan Car Accessories",
    group: 17,
    sortOrder: 65,
    slug: "fan-car-accessories",
    heading: [
      "Fan Car Accessories"
    ],
    subheading: []
  },
  "299": {
    label: "Fan Accessories",
    group: 17,
    sortOrder: 66,
    slug: "fan-accessories",
    heading: [
      "Fan Accessories"
    ],
    subheading: []
  },
  "300": {
    label: "Reference & Computers",
    group: 37,
    sortOrder: 109,
    slug: "reference-computers-books",
    heading: [
      "Reference & Computers"
    ],
    subheading: []
  },
  "301": {
    label: "Philosophy & Psychology",
    group: 37,
    sortOrder: 110,
    slug: "philosophy-psychology-books",
    heading: [
      "Philosophy & Psychology"
    ],
    subheading: []
  },
  "302": {
    label: "Religion & Spirituality",
    group: 37,
    sortOrder: 111,
    slug: "religion-spirituality-books",
    heading: [
      "Religion & Spirituality"
    ],
    subheading: []
  },
  "303": {
    label: "Society, Politics & Law",
    group: 37,
    sortOrder: 112,
    slug: "society-politics-law-books",
    heading: [
      "Society, Politics & Law"
    ],
    subheading: []
  },
  "304": {
    label: "Business & Money",
    group: 37,
    sortOrder: 113,
    slug: "business-money-books",
    heading: [
      "Business & Money"
    ],
    subheading: []
  },
  "305": {
    label: "Language & Dictionaries",
    group: 37,
    sortOrder: 114,
    slug: "language-dictionaries-books",
    heading: [
      "Language & Dictionaries"
    ],
    subheading: []
  },
  "306": {
    label: "Science & Nature",
    group: 37,
    sortOrder: 115,
    slug: "science-nature-books",
    heading: [
      "Science & Nature"
    ],
    subheading: []
  },
  "307": {
    label: "Home, Garden & How-To",
    group: 37,
    sortOrder: 116,
    slug: "home-garden-how-to-books",
    heading: [
      "Home, Garden & How-To"
    ],
    subheading: []
  },
  "308": {
    label: "Health & Medicine",
    group: 37,
    sortOrder: 117,
    slug: "health-medicine-books",
    heading: [
      "Health & Medicine"
    ],
    subheading: []
  },
  "309": {
    label: "Cookbooks",
    group: 37,
    sortOrder: 118,
    slug: "cookbooks",
    heading: [
      "Cookbooks"
    ],
    subheading: []
  },
  "310": {
    label: "Art & Photography",
    group: 37,
    sortOrder: 119,
    slug: "art-photography-books",
    heading: [
      "Art & Photography"
    ],
    subheading: []
  },
  "311": {
    label: "Crafts & Hobbies",
    group: 37,
    sortOrder: 120,
    slug: "crafts-hobbies-books",
    heading: [
      "Crafts & Hobbies"
    ],
    subheading: []
  },
  "312": {
    label: "Music Books & Sheet Music",
    group: 37,
    sortOrder: 121,
    slug: "music-books-sheet-music",
    heading: [
      "Music Books & Sheet Music"
    ],
    subheading: []
  },
  "313": {
    label: "Sports & Outdoors",
    group: 37,
    sortOrder: 122,
    slug: "sports-outdoors-books",
    heading: [
      "Sports & Outdoors"
    ],
    subheading: []
  },
  "314": {
    label: "Poetry, Plays & Essays",
    group: 37,
    sortOrder: 123,
    slug: "poetry-plays-essays-books",
    heading: [
      "Poetry, Plays & Essays"
    ],
    subheading: []
  },
  "315": {
    label: "History",
    group: 37,
    sortOrder: 124,
    slug: "history-books",
    heading: [
      "History"
    ],
    subheading: []
  },
  "316": {
    label: "Travel & Geography",
    group: 37,
    sortOrder: 125,
    slug: "travel-geography-books",
    heading: [
      "Travel & Geography"
    ],
    subheading: []
  }
};

// =============================================================================
// HELPER FUNCTIONS
// =============================================================================

/**
 * Get category group label by ID
 */
export const CatLabelsFromId = (id: number): string => {
  if (Cats[id]) return Cats[id].label;
  return "Other";
};

/**
 * Get subcategory label by ID
 */
export const SubCatLabelsFromId = (id: number): string => {
  if (SubCats[id]) return SubCats[id].label;
  return "Other";
};

/**
 * Get category group ID from subcategory ID
 */
export const GetGroupFromSubcat = (subcatId: number): number => {
  if (SubCats[subcatId]) return SubCats[subcatId].group;
  return 0;
};

/**
 * Check if a category is shippable
 */
export const IsShippableCategory = (catGroupId: number, subcatId?: number): boolean => {
  if (NON_SHIPABLE_CATS.includes(catGroupId)) return false;
  if (subcatId && NON_SHIPABLE_SUBCATS.includes(subcatId)) return false;
  return true;
};

/**
 * Get category slug by ID
 */
export const getCategorySlug = (id: number): string => {
  if (Cats[id]) return Cats[id].slug;
  return "";
};

/**
 * Get subcategory slug by ID
 */
export const getSubcategorySlug = (id: number): string => {
  if (SubCats[id]) return SubCats[id].slug;
  return "";
};

// =============================================================================
// LEGACY HELPER FUNCTIONS (For backwards compatibility)
// =============================================================================

/**
 * Get condition label by ID
 */
export const getConditionLabel = (conditionId: number | null | undefined): string => {
  if (conditionId === null || conditionId === undefined) return "";
  const condition = CONDITIONS.find(c => c.id === conditionId);
  if (condition) return condition.label;
  return "";
};

/**
 * Get category group by ID (alias for direct access)
 */
export const getCategoryGroupById = (id: number): any => {
  return Cats[id];
};

/**
 * Get category by ID (alias for direct access)
 */
export const getCategoryById = (id: number): any => {
  return SubCats[id];
};

/**
 * Get category slug by ID
 */
export const catSlugById = (id: number): string => {
  return getCategorySlug(id);
};

/**
 * Get category name by ID
 */
export const catNameById = (id: number): string => {
  return CatLabelsFromId(id);
};

/**
 * Get category group ID by slug (reverse lookup for category groups)
 */
export const categoryIdBySlug = (slug: string): number | null => {
  const entry = Object.entries(Cats).find(([_, cat]) => cat.slug === slug);
  return entry ? parseInt(entry[0]) : null;
};

/**
 * Get subcategory ID by slug (reverse lookup for subcategories)
 */
export const subcategoryIdBySlug = (slug: string): number | null => {
  const entry = Object.entries(SubCats).find(([_, subcat]) => subcat.slug === slug);
  return entry ? parseInt(entry[0]) : null;
};

/**
 * Get subcategory by slug (returns full object)
 */
export const getSubcategoryBySlug = (slug: string): { id: number; label: string; group: number; sortOrder: number; slug: string } | null => {
  const entry = Object.entries(SubCats).find(([_, subcat]) => subcat.slug === slug);
  if (!entry) return null;
  return { id: parseInt(entry[0]), ...entry[1] };
};

/**
 * Get category group by slug (returns full object)
 */
export const getCategoryGroupBySlug = (slug: string): { id: number; label: string; sortOrder: number; slug: string } | null => {
  const entry = Object.entries(Cats).find(([_, cat]) => cat.slug === slug);
  if (!entry) return null;
  return { id: parseInt(entry[0]), ...entry[1] };
};

/**
 * Get all subcategories for a category group
 */
export const getSubcategoriesByGroupId = (groupId: number): Array<{ id: number; label: string; group: number; sortOrder: number; slug: string }> => {
  return Object.entries(SubCats)
    .filter(([_, subcat]) => subcat.group === groupId)
    .map(([id, subcat]) => ({ id: parseInt(id), ...subcat }))
    .sort((a, b) => a.sortOrder - b.sortOrder);
};

/**
 * Get all category IDs
 */
export const ALL_CATEGORIES = (): number[] => {
  return Object.keys(SubCats).map(Number);
};
